import { CloseOutlined } from "@ant-design/icons";
import { Button, Input, InputRef } from "antd";
import * as React from "react";
import { safeFocus } from "src/common/safeFocus";

import * as styles from "./TextDropdownFilter.module.less";

type PropsTextDropdownFilter = {
  currentValue: string | null | undefined;
  apply: (text: string) => void;
  cancel: () => void;
};

export const TextDropdownFilter: React.FC<PropsTextDropdownFilter> = (
  props,
) => {
  const { apply, currentValue, cancel } = props;
  const currentText = currentValue ?? "";
  const iref = React.useRef<InputRef>(null);
  React.useEffect(() => {
    safeFocus(iref.current);
  }, [iref.current]);
  const [text, setText] = React.useState("");
  React.useEffect(() => {
    setText(currentText);
  }, [currentValue]);
  const onCancel = () => {
    setText(currentText);
    cancel();
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className={styles.box} onKeyDown={(e) => e.stopPropagation()}>
      <div className={styles.inputBox}>
        <Input
          ref={iref}
          allowClear
          value={text}
          onChange={(e) => setText(e.currentTarget.value)}
          onPressEnter={(e) => {
            e.preventDefault();
            e.stopPropagation();
            apply(text);
          }}
        />
        <Button
          size="small"
          type="text"
          icon={<CloseOutlined />}
          onClick={onCancel}
        />
      </div>
      <div className={styles.buttons}>
        <Button disabled={!currentText} onClick={() => apply("")}>
          Сбросить
        </Button>
        <div className={styles.ok}>
          <Button
            type="primary"
            onClick={() => apply(text)}
            disabled={currentText === text}
          >
            Применить
          </Button>
        </div>
      </div>
    </div>
  );
};
